import React, { useState } from 'react';
import { Grid, IconButton,  Box, Typography } from '@mui/material';
// import AutoPlaySwipeableCarousel from '../components/AutoPlaySwipeableCarousel';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ApplyGivecard from './ApplyGivecard';
import DonationCost from './DonationCost';
import PaymentMethod from './PaymentMethod';
import LetsGoBeforeFinish from './LetsGoBeforeFinish';
import DonationSuccess from './DonationSuccess';
import DonorTaxInformation  from './DonorTaxInformation';
import RemainFunds from './RemainFunds';
import BackIcon from '../assets/backIcon.svg';
import { appConfig } from "../app-config";

// const carouselImages = [
//     {
//       label: 'Help Sponsor an Autism Service Dog at NSD',
//       subLabel: 'By National Service Dogs',
//       imgPath:
//         'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
//     },
//     {
//       label: 'Help Sponsor an Autism Service Dog at NSD2',
//       subLabel: 'By National Service Dogs',
//       imgPath:
//         'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
//     },
//     {
//       label: 'Help Sponsor an Autism Service Dog at NSD3',
//       subLabel: 'By National Service Dogs',
//       imgPath:
//         'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
//     },
//     {
//       label: 'Help Sponsor an Autism Service Dog at NSD4',
//       subLabel: 'By National Service Dogs',
//       imgPath:
//         'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
//     },
// ];

const Payment = () => {
  const getDataFive =() => {
    const queryParams = new URLSearchParams(window.location.search);
    let dataFive = queryParams.get('dataFive');
  
    if (!dataFive && window.location.hash) {
      const hashParams = new URLSearchParams(window.location.hash.slice(1));
      dataFive = hashParams.get('dataFive');
    }
  
    return dataFive;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('dataOne');
  const name = urlParams.get('dataThree');
  const sub_name = urlParams.get('dataFour');
  const image = getDataFive();
  const supplier_id = urlParams.get('dataTwo');
  const userId = urlParams.get('dataSix');
  const paymentMethodId = urlParams.get('dataSeven') ?  urlParams.get('dataSeven')?.split(',') : [];
  const venorId = urlParams.get('dataEight');
  const currentLanguage = urlParams.get('dataNine') || "en";
  const csrfToken = urlParams.get('dataTen');
  const sessionId = urlParams.get('dataEleven');
  const stepId = Number(urlParams.get('dataTwelve')) ||  0;
  const [isButtonVisible, setIsButtonVisible] = useState(userId !== "None" ? false : true);

  const [currentStep, setCurrentStep] = useState(stepId);
  const [sharedData, setSharedData] = useState({"projectId": id, "supplier_id": Number(supplier_id), "projectName": name, userId: userId, projectImage: image, venorId: venorId,"paymentMethodId": paymentMethodId,"language":currentLanguage, "csrfToken": csrfToken, "sessionId": sessionId});

  const updateSharedData = (data) => {
    setSharedData(data);
  };
  
  const handleNext = (step) => {
    if (typeof step === 'number') {
      setCurrentStep(step);
    } else {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };
  

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const handleBackToTab1 = () => {
    window.location.reload();
    window.parent.postMessage("switchToTab1", "*");
  };

  const onBackButtonClick = (showButton) => {
    setIsButtonVisible(showButton);
  };
  const divStyle = {
    backgroundImage: `url(${appConfig.WEB_URL}/${image})`,
  };

  return (
    <div>
      <Grid container spacing={2} style={{margin: 0, width: '100%'}}>
        <Grid item xs={12} style={{ justifyContent: 'center', display: 'flex', padding:0 }}>
          <Card variant="outlined" sx={{ width: "100%", border: 'none' }}>
            <div style={{ position: 'relative' }}>
            {/* {currentStep === 1 && isButtonVisible &&(
                <IconButton aria-label="back button" id="step1BackBtn" className="back-btn" onClick={handleBackToTab1}>
                  <img src={BackIcon} alt="back icon" />
                </IconButton>
              )} */}
              {currentStep !== 0 &&  currentStep !== 3 &&   currentStep !== 4 && currentStep !== 5 && (
                <IconButton aria-label="back button" className="back-btn" onClick={handleBack}>
                  <img src={BackIcon} alt="back icon" />
                </IconButton>
              )} 
              {currentStep !== 3 && (
                // <AutoPlaySwipeableCarousel images={carouselImages} />
                <div style={{ paddingBottom: 5}}>
                    <div style={divStyle} className="img-top">
                      <div className='image-over-text'>
                        <Typography className='query-head' style={{color: "#fff", marginBottom: 6}}>{name}</Typography>
                        <Typography className="normal-text mb-30" style={{color: "#fff"}}>{sub_name}</Typography>
                      </div>
                    </div>
              </div>
              )}
            </div>
            <CardContent style={{padding: "24px 32px"}}>
                  {currentStep === 0 && <ApplyGivecard sharedData={JSON.parse(sessionStorage.getItem("sharedData"))? JSON.parse(sessionStorage.getItem("sharedData")) : sharedData}  onBackButtonClick={onBackButtonClick} updateSharedData={updateSharedData} handleNext={handleNext}/>}
                  {/* {currentStep === 1 && <DonationCost sharedData={sharedData} updateSharedData={updateSharedData} handleNext={handleNext}/>} */}
                  {currentStep === 1 && <PaymentMethod sharedData1={sharedData} updateSharedData={updateSharedData} handleNext={handleNext} handleBack={handleBack}/>}
                  {currentStep === 2 && <LetsGoBeforeFinish sharedData={sharedData} updateSharedData={updateSharedData} handleNext={handleNext} handleBack={handleBack} />}
                  {currentStep === 3 && <DonationSuccess sharedData={sharedData} updateSharedData={updateSharedData} handleNext={handleNext} handleBack={handleBack}/>}  
                  {currentStep === 4 && <DonorTaxInformation sharedData={sharedData} updateSharedData={updateSharedData} handleNext={handleNext} handleBack={handleBack}/>}       
                  {currentStep === 5 && <RemainFunds sharedData={sharedData} updateSharedData={updateSharedData} handleNext={handleNext}/>}       
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default Payment;
